<template xmlns="http://www.w3.org/1999/html">
  <div class="page-role background-image">
    <div class="role-title wd-col">
      <div class="role--title-img"></div>
    </div>
    <div class="role-content">
      <span class="mb-md text-bold">一、活动时间 </span>
      <span class="mb-md text-indent">即日起至2022年12月31日</span>
      <span class="mb-md text-bold">二、活动对象</span>
      <span class="mb-md text-indent">新疆电信用户</span>

      <span class="mb-md text-bold">三、活动说明</span>
      <span class="mb-md text-indent">活动期间，用户登录活动页面并按要求完成任务即可获得全国通用流量，所有任务仅限完成1次。</span>
      <span class="mb-md text-indent">打开备份方式：点击APP首页底部“我的”→“相册备份”→打开“后台自动备份”。</span>
      <span class="mb-md text-indent">上传成功的照片/视频/文件/音乐将存放在您的天翼云盘文件中，点击APP首页底部“文件”，即可在文件中查看所上传照片/视频/文件/音乐。</span>

      <span class="mb-md text-bold">四、全国通用流量</span>
      <span class="mb-md text-indent">完成指定任务即可收到对应的全国通用流量奖励，立即生效。当月月底清零，不会产生费用。可用于 5G、4G上网方式，限在中国大陆境内（不含港澳台地区）使用，不含 WLAN（wi-fi）上网。</span>
      <span class="mb-md text-indent">需套餐内所有用户都开通了VoLTE功能（开通之后再来点击立即领取，即可领取成功），并且用户号码须处于正常可用状态才可获赠全国通用流量产品。处于紧急停机（挂失）、欠费停机、停机保号等状态的后付费用户及处于未激活期、充值期、锁定期的预付费用户不可获赠，如因套餐产品互斥等原因而无法成功获赠的，请咨询10000号。</span>

      <span class="mb-md text-bold">五、参与活动前请用户详细阅读活动规则及相关条款</span>
      <span class="mb-md text-indent">凡参与本次活动，则视为用户已阅读、理解并同意活动规则及免责条款全部内容。</span>

      <span class="mb-md text-bold">六、禁止用户以任何不正当手段及舞弊行为参与本活动</span>
      <span class="mb-md text-indent">一经发现，天翼云盘有权取消该用户参与活动的资格，并保留追究该用户责任的权利。不正当手段及舞弊行为包括但不限于：使用插件、外挂、系统或第三方工具对客户端及本活动进行干扰、破坏、修改或施加其他影响及天翼云盘认为的其他不正当手段。</span>

    </div>
    <div class="role-return-btn pb-xxxl">
      <button class="bg-red-deep round-8 pl-lg pr-lg pt-xs pb-sm" @click="$router.go(-1)">返回首页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Role"
}
</script>

<style lang="scss">
.page-role {
  width: 100%;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
  -o-background-size:100% 100%;

  .role-title {
    width: 100%;
    text-align: center;
    padding: 40px 40px 0 40px;
  }

  .role-content {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    padding: 0 24px 24px 24px;
    color: #0f1923;
  }

  .role-return-btn {
    text-align: center;

    button {
      width: auto;
      border: none;
      color: white;
      font-size: 16px;

      &:active {
        color: #efefef;
        opacity: 0.9;
        box-shadow: 0 2px 2px 2px rgba(#2d8ff5, .15), 0 0 2px 2px rgba(#2d8ff5, .15);
      }
    }
  }
}
</style>
